import Http from "./Http";

export class NotificationsService extends Http {
  /**
   * Get list of FAQ's category
   * @param {Object} params
   * @param {boolean} params.cursor
   * @param {boolean} params.limit
   * @param {number} params.direction 1 - NEXT, 2 - PREVIOUS
   */
  getNotifications(params) {
    return this.get("/notifications", { params });
  }

  /**
   * Get list of FAQ's category
   */
  getNotificationsCount() {
    return this.get("/notifications/count");
  }

  /**
   * Hide notification
   * @param {number} id
   */
  hideNotification(id) {
    return this.patch(`/notifications/${id}/is-hide`);
  }

  /**
   * Mark all notifications as read
   */
  readNotifications() {
    return this.patch(`/notifications/is-read`);
  }
}

export default new NotificationsService();
